module.exports = __webpack_public_path__ + "7c1f5ba940e3ab23e5a00cc992896c47.pdf";